/*
*
* File JS componente Block Code
*
*/

 
// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './index.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockCode = () => {
}


export default blockCode;

//--------------------------------------------------------------------//